module.exports = "<select class=\"flow-picker form-control\" (change)=\"onChange()\" [(ngModel)]=\"selectedId\">\r\n  <option *ngIf=\"loading\" disabled [ngValue]=\"null\" l10nTranslate>flowpicker-loading</option>\r\n  <option *ngIf=\"!loading\" disabled [ngValue]=\"null\" l10nTranslate>{{this.actionDescriptionKey}}</option>\r\n  <option *ngFor=\"let flow of flows\" [ngValue]=\"flow.Identifier\">{{flow.Name}}</option>\r\n</select>"


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/src/app/flow-picker/flow-picker.component.html
// module id = ../../../../../src/app/flow-picker/flow-picker.component.html
// module chunks = 1